import { Badge, formatTimeDate } from "@";

export const tableColumns = [
  {
    grow: 2,
    name: " الهاتف",
    selector: ({ phoneNumber }) => phoneNumber,
  },
  {
    grow: 2,
    name: " تاريخ الارسال",
    selector: ({ smsSentAt }) => formatTimeDate(smsSentAt),
  },

  {
    grow: 2,
    name: "اسم المجموعة",
    selector: ({ campaignKey }) => campaignKey,
  },

  {
    grow: 2,
    name: " حالة الارسال",
    cell: ({ isSmsSent }) => (
      <Badge
        color={isSmsSent ? "green" : "red"}
        title={isSmsSent ? "تم الارسال" : "لم يتم الارسال"}
      />
    ),
  },
  {
    grow: 2,
    name: "نسخ الحساب البنكي",
    cell: (row) => (
      <div className="flex flex-col gap-1.5">
        <Badge
          className="w-fit"
          color={row.hasIbanCopied ? "green" : "red"}
          title={row.hasIbanCopied ? "تم النسخ" : "لم يتم النسخ"}
        />
        {row.hasIbanCopied && (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatTimeDate(row.ibanCopiedAt)}
          </p>
        )}
      </div>
    ),
  },
  {
    grow: 2,
    name: "عملية الدفع",
    cell: (row) => (
      <div className="flex flex-col gap-1.5">
        <Badge
          className="w-fit"
          color={row.hasOrderCompleted ? "green" : "red"}
          title={row.hasOrderCompleted ? "تم الدفع" : "لم يتم الدفع"}
        />
        {row.hasOrderCompleted && (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatTimeDate(row.orderCompletedAt)}
          </p>
        )}
      </div>
    ),
  },
  {
    grow: 2,
    name: "النقر على الرابط",
    cell: (row) => (
      <div className="flex flex-col gap-1.5">
        <Badge
          className="w-fit"
          color={row.hasLinkVisited ? "green" : "red"}
          title={row.hasLinkVisited ? "تم النقر" : "لم يتم النقر"}
        />
        {row.hasLinkVisited && (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatTimeDate(row.linkVisitedAt)}
          </p>
        )}
      </div>
    ),
  },
];
